import FormatData from "@/application/FormatData";
import BaseContainer from "@base/container/BaseContainer";
import AddComponent from "@base/utils/AddComponent";
import {Signals} from "@/Imports";
import Facade from "@/Facade";
import UIConfig from "@baseUI/config/UIConfig";


export default class BuyFeatureContainer extends BaseContainer {

    constructor(data) {
        super(data)
        this.init()
    }

    init() {
        Signals.currentBuyFreebetChanged.add(() => {
            this.changePrice(Facade.model.currentBetIndex,false)
        }, this);


        this.shadow = AddComponent.addShadow(this, { x:0, y: 0, width : UIConfig.totalWidth, height: UIConfig.totalHeight},0x000000, 0.5)
        const buyContainer = AddComponent.addContainer(this, {x: UIConfig.totalWidth/2, y: UIConfig.totalHeight/2 - 100})
        AddComponent.addElement('board', buyContainer, [0, 0], 'buyFeature', 1, 0.5)

        AddComponent.addElement('amount', buyContainer, [0, -200], 'buyFeature', 1, 0.5)
        const betImage = AddComponent.addElement('bet', buyContainer, [0, 120], 'buyFeature', 1, 0.5)
        AddComponent.addElement('bet_amount', buyContainer, [0, 200], 'buyFeature', 1, 0.5)

        AddComponent.addElementText('buyFreeSpinBet', 'freeBetBuyWhite', betImage, [0, 0])
        AddComponent.addElementText('buyFreeSpinCaptionCount', 'freeBetBuyWhite', betImage, [0, -80])


        const textureCloseBtn = {
            up: 'buyFeature/close_button_normal',
            down: 'buyFeature/close_button_down',
            over: 'buyFeature/close_button_over',
            disable: 'buyFeature/close_button_disabled'
        }
        this.btnClose = AddComponent.addButton(textureCloseBtn, buyContainer, [0, -310], 1.2)
        this.btnClose.on('tapButton', ()=>{
          this.hide()
        })

        const textureMinusBtn = {
            up: 'buyFeature/minus_button_normal',
            down: 'buyFeature/minus_button_down',
            over: 'buyFeature/minus_button_over',
            disable: 'buyFeature/minus_button_disable'
        }
        this.btnMinus = AddComponent.addButton(textureMinusBtn, buyContainer, [-250, 200], 1.3)
        this.btnMinus.on('tapButton', ()=>{
            Signals.playBuyDecreaas.dispatch()
            this.changePrice(this.activeBetIndex - 1)
        })

        const texturePlusBtn = {
            up: 'buyFeature/plus_button_normal',
            down: 'buyFeature/plus_button_down',
            over: 'buyFeature/plus_button_over',
            disable: 'buyFeature/plus_button_disable'
        }
        this.btnPlus = AddComponent.addButton(texturePlusBtn, buyContainer, [250, 200], 1.3)
        this.btnPlus.on('tapButton', ()=>{
            Signals.playBuyIncreas.dispatch()
            this.changePrice(this.activeBetIndex + 1)
        })
        const textureBuyBtn = {
            up: 'buyFeature/buy_button_normal',
            down: 'buyFeature/buy_button_down',
            over: 'buyFeature/buy_button_over',
            disable: 'buyFeature/buy_button_disabled'
        }
        this.btnBuy = AddComponent.addButton(textureBuyBtn, buyContainer, [0, 295], 1.2)
        this.btnBuy.on('tapButton', ()=>{
            Facade.model.currentBetIndex = this.activeBetIndex
           // document.dispatchEvent(new CustomEvent('changeBets', {detail: { value: this.activeBetIndex }}))
            document.dispatchEvent(new CustomEvent('tap', {detail: {
                    id: Facade.model.buyFreebet[0].id,
                    price: Facade.model.buyFreebet[0].price,
                    name: 'buyConfirm'
                }}))
            this.hide()
        })
        AddComponent.addElementText('buyFreeSpinButtonBuy', 'splashScreen', this.btnBuy, [0, 0])


        this.countBuyFreeSpins = AddComponent.addElementBitmapText('12', {font: {name: 'fontWin', size: '100px'}, align: 'center'}, buyContainer, [-20, -80])

        this.buyPriceDynamic = AddComponent.addElementDynamicText('freeBetBuyWhite', buyContainer, [0, -200])
        // Signals.setWin.add((value) => {
        //     this.buyPriceDynamic.text = `${Facade.model.possibleBets[value]}`
        // })
        this.buyBetDynamic = AddComponent.addElementDynamicText('freeBetBuyWhite', buyContainer, [0, 200])

      //  const buyFreebet = Facade.model.buyFreebet
//         this.changePrice(0)

       //  Signals.setValue.dispatch('buyPanelCount', `x${buyFreebet[0].amount}`)

        // addComponent('buyPanelCount', this.buyContainer)
        // //  this.textWinLeft = Facade.GlobalListComponents.get('buyWinCaptionLeft_TEXT')
        // Facade.model.currentBuyFreebetIndex = 0


        //Signals.showBuyFeature.add(this.show, this)
        Signals.buyFeatureOpen.add(this.show, this)
        this.visible = false
    }

    show(){
        this.visible = true
        this.changePrice(Facade.model.currentBetIndex)
    }

    setActiveButton(index) {
        if (index >= Facade.model.betPossible.length - 1){
            this.btnPlus.disable()
        } else {
            this.btnPlus.enable()
        }
        if (index <= 0){
            this.btnMinus.disable()
        }else {
            this.btnMinus.enable()
        }
        this.activeBetIndex = index
    }

    changePrice(activeBetIndex, dispatchBetChanged = true){
        this.countBuyFreeSpins.text =  Facade.model.buyFreebetAmount
        const totalBuyListBet = Facade.model.totalBuyListBet
        this.setActiveButton(activeBetIndex)

        this.buyBetDynamic.text = `${Facade.model.totalBetsList[activeBetIndex]}`
        this.buyPriceDynamic.text = `${FormatData.formatToCoins(totalBuyListBet[activeBetIndex][0])}`

        Facade.model.currentBetIndex = this.activeBetIndex

        if(dispatchBetChanged)
            Signals.betChanged.dispatch({value: this.activeBetIndex, currentBetIndex: Facade.model.currentBetIndex})
    }

    hide(){
        this.visible = false
    }
}
